import React, { useState } from 'react';
import { FORM_FIELDS } from '../../../constants/widget-configuration/widget-configuration-form';
import { useTranslation } from 'react-i18next';
import { IRGBColor } from '../sites/ColorModule';
import { Label } from '../page-components/Label';
import { Input } from '../page-components/Input';
import { ErrorContainer } from '../page-components/ErrorContainer';
import { WidgetColorPicker } from '../page-components/ColorPicker';
import clsx from 'clsx';
import { InputType } from '../../form/form-input-constants';


interface Props {
	formik: any;
	fieldLabel: string;
	fieldName: string;
	placeholder: string;
	isCheckbox?: boolean;
	isAdmin?: boolean;
	colorPicker?: (item: IRGBColor) => void;
	additionalClassname?: string;
}

export const ChangeColorInput = (props: Props): React.ReactElement => {
	const { formik, fieldLabel, fieldName, placeholder, isCheckbox, colorPicker, isAdmin, additionalClassname } = props;
	const { t } = useTranslation();

	const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);

	const onInputClick = (): void => {
		setDisplayColorPicker(true);
	};

	const colorPickerClose = (): void => {
		setDisplayColorPicker(false);
	};

	const colorChange = (color): void => {
		formik.setFieldValue(fieldName, color.hex);
		isCheckbox && colorPicker(color.rgb);
	};

	const value = formik.getFieldProps(fieldName).value;

	return (
		<div className={clsx('input-container', additionalClassname ? additionalClassname : 'col-6')}>
			{
				isAdmin && (
					<>
						<Label
							fieldLabel={fieldLabel}
							additionalClass={isCheckbox && 'mb-10'}
							isStandardClass
							required
						>
							<Input
								formik={formik}
								fieldLabel={fieldLabel}
								fieldName={fieldName}
								inputType={InputType.Text}
								placeholder={placeholder}
								onInputClick={onInputClick}
								additionalClass="cursor-pointer mb-3"
								readOnly
							/>

						</Label>
						<ErrorContainer formik={formik} fieldName={fieldName} additionClass="error-container position-absolute"/>

						<WidgetColorPicker
							value={value}
							onInputClick={onInputClick}
							displayColorPicker={displayColorPicker}
							colorPickerClose={colorPickerClose}
							colorChange={colorChange}
						/>
					</>
				)
			}
			{
				isCheckbox && (
					<Input
						formik={formik}
						inputType="checkbox"
						fieldLabel={t('COLOR_MODULE.CHECKBOX_TITLE')}
						checkboxFieldName={FORM_FIELDS.VISIBLE}
						disabled={!formik.values[FORM_FIELDS.LOGO_FILE]}
					/>
				)
			}

		</div>
	);
};
